export default __webpack_public_path__ + "static/media/dai.c8d21a9e.png";